import { useEffect, useState } from "react";
import { searchLivingAreas } from "../../../repository/RealEstateRepository";
import { LivingAreaList } from "../organism";
import { DefaultPage } from "./";

const links = [
  {
    title: "Home",
    to: "/realestate"
  },
  {
    title: "LivingArea",
  }
];

const LivingAreaListPage = (props) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    searchLivingAreas({}, (v) => setItems(v.content));
  }, []);

  return (<>
    <DefaultPage pathname={props.location.pathname} links={links}>
      <LivingAreaList items={items} />
    </DefaultPage>
  </>);
};

export { LivingAreaListPage };
